import Vue from 'vue';
export const SET_WANG_BUY_DETAILS = (state, data) => { 
    state.wantBuyDetails = {};
    state.wantBuyDetails =  data
}

export const COUNT_TOTAL_OFFER = (state, data) => {
    let listData = data
    let countAll = 0
    listData.forEach((comm, index) => {
        if (comm.tails&&comm.tails.wantOfferDetail) {
            let countOne = comm.tails.wantOfferDetail.buy_num * parseFloat(comm.tails.wantOfferDetail.offer_unit_price/100);
            countAll = countAll + countOne
        }
    })
    state.willOfferCountTotail = countAll
}
export const SET_WANG_OFFER_LIST = (state, data) => {
    state.wantBuyDetails = {};
    state.wantOfferList =  data
}


// WEBPACK FOOTER //
// ./src/view/procurement/store/mutation.js